import {CgWebsite } from "react-icons/cg";
import { BsCodeSlash} from "react-icons/bs";
import { DiCodeigniter} from "react-icons/di";
import { FaCodeBranch} from "react-icons/fa";
import { MdOutlineCode} from "react-icons/md";
import { SiPluscodes} from "react-icons/si";
import { TbMessageCode} from "react-icons/tb";
const Ser=[
    {
      id:1,
      icon:{FaCodeBranch},
      title:"Web Development",
      desc:"I do some reserches before I start the job. To choose the right way for the job."
    },
     {
      id:2,
      icon:{BsCodeSlash},
      title:"Beautiful Code",
      desc:"Working on the way of writing code to make it better and clean readable for everyone."
    },

     {
      id:4,
      icon:{CgWebsite},
      title:"Quick Learner",
      desc:"I always ready to learn something new things and I have the ability of Quick learner."
    },
     {
      id:5,
      icon:{MdOutlineCode},
      title:"Online",
      desc:"I am always available and easy to reach."
    },
     {
      id:6,
      icon:{TbMessageCode},
      title:"Made with Love",
      desc:"Is it really open source if it's not made with love? Always be certain when you use our website."
    },
  
   
     {
      id:3,
      icon:{DiCodeigniter},
      title:"Fully Responsive",
      desc:"  I design my websites to be responsive and work on different devices properly."
    },
     {
      id:4,
      icon:{CgWebsite},
      title:"Quick Learner",
      desc:"I always ready to learn something new things and I have the ability of Quick learner."
    },
     {
      id:6,
      icon:{TbMessageCode},
      title:"Made with Love",
      desc:"Is it really open source if it's not made with love? Always be certain when you use our website."
    },
    
    
]

export default Ser